import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { UI } from '../constants';

export function MonoLabel({ children, color }) {
  const resolvedColor = color || UI.textFaint;
  return (
    <Typography
      sx={{
        fontFamily: UI.mono,
        fontSize: 11,
        letterSpacing: '0.14em',
        textTransform: 'uppercase',
        color: resolvedColor,
      }}
    >
      {children}
    </Typography>
  );
}

MonoLabel.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
};

export function Caret() {
  return (
    <Box component="span" sx={{ fontSize: 11, color: UI.textMuted, ml: 0.75 }}>
      ▾
    </Box>
  );
}

export function SelectorButton({ primary, secondary, onClick }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        px: 1.25,
        py: 0.85,
        borderRadius: 1.5,
        cursor: 'pointer',
        border: `1px solid ${UI.border}`,
        bgcolor: 'rgba(255,255,255,0.03)',
        '&:hover': { bgcolor: 'rgba(255,255,255,0.06)' },
      }}
    >
      <Box sx={{ textAlign: 'right' }}>
        <Typography sx={{ fontSize: 14, fontWeight: 700, color: UI.text, lineHeight: 1.1 }}>
          {primary}
        </Typography>
        {secondary && (
          <Typography sx={{ fontSize: 10.5, color: UI.textMuted, fontFamily: UI.mono }}>
            {secondary}
          </Typography>
        )}
      </Box>
      {/* <Caret /> */}
    </Box>
  );
}

SelectorButton.propTypes = {
  primary: PropTypes.string.isRequired,
  secondary: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export function QuoteRow({ label, value, valueColor }) {
  const color = valueColor || UI.text;
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography sx={{ fontSize: 12.5, color: UI.textMuted }}>{label}</Typography>
      <Typography sx={{ fontSize: 12.5, fontWeight: 700, color }}>{value}</Typography>
    </Stack>
  );
}

QuoteRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
  valueColor: PropTypes.string,
};
